const STATUS_STYLES: Record<string, { bg: string; fg: string }> = {
  new:       { bg: "hsl(210,90%,94%)", fg: "hsl(210,100%,32%)" },
  contacted: { bg: "hsl(38,92%,92%)",  fg: "hsl(32,80%,34%)"  },
  qualified: { bg: "hsl(265,80%,94%)", fg: "hsl(265,55%,40%)" },
  customer:  { bg: "hsl(142,55%,92%)", fg: "hsl(142,72%,28%)" },
  lost:      { bg: "hsl(0,80%,94%)",   fg: "hsl(0,72%,42%)"   },
  dormant:   { bg: "hsl(210,16%,93%)", fg: "hsl(215,16%,40%)" },
};

function humanize(v: string): string {
  return v.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function LeadStatusBadge({ status }: { status: string }) {
  const s = STATUS_STYLES[status] ?? STATUS_STYLES.dormant;
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium"
      style={{ background: s.bg, color: s.fg }}
    >
      {humanize(status)}
    </span>
  );
}
